import getWithToken from "./base/get-with-token";
import postWithToken from "./base/post-with-token";

const getSignedUrlJsonAzure = (data) =>
  postWithToken(`/devices/download-file-json`)(data);

export default getSignedUrlJsonAzure;
